import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { GuestApi } from './api/client';
import { App } from './ui/App';
import './styles.css';

/**
 * Boot.
 *
 * The shortest of the three front ends, and the shortness is the design. There
 * is no IndexedDB to open (a guest has no offline story — they are on a phone,
 * on a website, about to book), no service worker (the CDN caches the hashed
 * assets and `index.html` is `no-cache`, so a deploy is live everywhere in one
 * request), and **no configuration at all**: the API is same-origin because the
 * load balancer sends `/api/*` on any tenant hostname to `guest-api` and
 * everything else to this bundle's bucket (spec §6.4.2).
 *
 * There is also no `VITE_TENANT_*` of any kind, and there must never be one.
 * Which tenant this is comes from the Host header at ingress — the destination
 * address, never the content — so a build-time tenant would be the first crack
 * in "one static build for every tenant hostname" and the beginning of an app
 * per tenant.
 */
const container = document.getElementById('root');
if (container === null) throw new Error('no #root');

createRoot(container).render(
  <StrictMode>
    <App api={new GuestApi()} />
  </StrictMode>,
);
